import { Container } from "react-bootstrap";
import EmptyState from "../../components/emptyState";

const Index = () => {
  return (
    <Container>
      <EmptyState />
    </Container>
  );
};

export default Index;
